export default __webpack_public_path__ + "static/media/next_arrow_disabled.bac56d7a.svg";